import { FC } from "react";
import { useDispatch } from "react-redux";

import type { AppDispatch } from "store";
import { addDrawingTool } from "../model";
import type { DrawingToolName } from "../model";
import { TOOLS } from "./config";

import styles from "./styles/SelectDrawingTool.module.css";

export const AllToolsList: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const handleToolClick = (name: DrawingToolName) => {
    dispatch(addDrawingTool(name));
  };

  return (
    <ul className={styles.list}>
      {TOOLS.map((tool) => (
        <li
          key={tool.name}
          className={styles.item}
          onClick={() => handleToolClick(tool.name)}
        >
          {tool.icon}
          <span>{tool.label}</span>
        </li>
      ))}
    </ul>
  );
};
